<template>
  <div class="tree-counter">
    <div class="tree-val">{{ counterString }}</div>
    <div class="tree-caption">
      {{ $nippets.trees }}
    </div>
  </div>
</template>

<script>

const totalTreesAtTimeKnown = 1044932.0
const treesPerHour = 13.0

export default {
  data () {
    return {
      counter: 0,
      timeoutId: 0
    }
  },
  computed: {
    counterString: function () {
      return this.counter.toLocaleString()
    }
  },
  mounted () {
    this.countTrees()
    this.timeoutId = window.setInterval(() => {
      this.countTrees()
    }, 2000)
  },
  methods: {
    countTrees: function () {
      let timenow = new Date().getTime();
      let timeknown = new Date(2018, 6, 9).getTime()
      
      let treesPerTick = treesPerHour / 60.0 / 60.0 / 1000.0
      let diff = timenow - timeknown
      let count = totalTreesAtTimeKnown + (treesPerTick * diff)
      this.counter = Math.round(count)
    }
  },
  beforeDestroy () {
    console.log('clearing timeout ' + this.timeoutId)
    window.clearInterval(this.timeoutId)
  }
}
</script>

<style>
.tree-counter{
  display:flex;
  line-height:36px;
  font-weight:500;
  margin: 20px 0;
}

.tree-val{
  padding:0 12px;
  font-size:19px;
  box-sizing:border-box;
  border-top:1px solid #999;
  border-left:1px solid #999;
  border-bottom:1px solid #999;
}

.tree-caption{
  background-color:#7bb742;
  padding:4px 12px 0 12px;
  font-size:14px;
  color:#fff;
  text-transform: uppercase;
  line-height:32px;
}
</style>
